/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { MenuItem } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AdxCheckbox from './AdxCheckbox'

const AdxMenuItemCreateEval = ({ 'data-value': value, children, selectedvalue, sx, ...rest }) => {
  //Props:
  // selectedvalue: string. props can be passed from the parent component to check whether the item is selected.
  const [selected, setSelected] = useState(false)
  const theme = useTheme()
  useEffect(() => {
    if (selectedvalue === value || selectedvalue.id === value.id) {
      setSelected(true)
    } else {
      setSelected(false)
    }

    if (selectedvalue?.length > 0) {
      selectedvalue?.map((item) => {
        if (item === value || item.id === value.id) {
          setSelected(true)
        }
      })
    }
  }, [selectedvalue, value])

  return (
    <MenuItem
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        px: 2,
        py: 1.25,
        backgroundColor: selected ? `${theme.palette['light-alternate'].main} !important` : null,
        '&.Mui-selected': {
          backgroundColor: `${theme.palette['light-alternate'].main} !important`,
        },
        '&:hover': {
          backgroundColor: `${theme.palette['gray-background'].main} !important`,
        },
        ...sx,
      }}
      {...rest}
    >
      <AdxCheckbox checked={selected} inputProps={value} />
      {children}
    </MenuItem>
  )
}

export default AdxMenuItemCreateEval
